import check_mark from "../../images/check-mark.png";
export default function Addittional({ el } ) {
  return (
    <div>
      <p style={{ fontWeight: "bold", fontSize: 25 }}>ԼՐԱՑՈՒՑԻՉ</p>
      <div className="addittional">
        {el.individual_heating && (
          <span>
            <img src={check_mark} alt="" />
            ԱՆՀԱՏԱԿԱՆ ՋԵՌՈՒՑՈՒՄ
          </span>
        )}
        {el.central_heating && (
          <span>
            <img src={check_mark} alt="" />
            ԿԵՆՏՐՈՆԱՑՎԱԾ ՋԵՌՈՒՑՈՒՄ
          </span>
        )}

        {el.conditioner && (
          <span>
            <img src={check_mark} alt="" />
            ՕԴՈՐԱԿԻՉ
          </span>
        )}
        {el.furniture && (
          <span>
            <img src={check_mark} alt="" />
            ԿԱՀՈՒՅՔ
          </span>
        )}
        {el.equipment && (
          <span>
            <img src={check_mark} alt="" />
            ՏԵԽՆԻԿԱ
          </span>
        )}
        {el.outdoor_balcony && (
          <span>
            <img src={check_mark} alt="" />
            ԲԱՑ ՊԱՏԺԳԱՄԲ
          </span>
        )}
        {el.kitchen && (
          <span>
            <img src={check_mark} alt="" />
            ԱՌԱՆՋԻՆ ԽՈՀԱՆՈՑ
          </span>
        )}
        {el.elevator && (
          <span>
            <img src={check_mark} alt="" />
            ՎԵՐԵԼԱԿ
          </span>
        )}
        {el.basement && (
          <span>
            <img src={check_mark} alt="" />
            ՆԿՈՒՂ(-1)
          </span>
        )}
        {el.attic && (
          <span>
            <img src={check_mark} alt="" />
            ՁԵՂՆԱՀԱՐԿ
          </span>
        )}
        {el.storage_room && (
          <span>
            <img src={check_mark} alt="" />
            ԽՈՐԴԱՆՈՑ
          </span>
        )}
        {el.underfloor_heating && (
          <span>
            <img src={check_mark} alt="" />
            ՏԱՔԱՑՎՈՂ ՀԱՏԱԿ
          </span>
        )}
        {el.sunny_side && (
          <span>
            <img src={check_mark} alt="" />
            ԱՐԵՎԿՈՂ
          </span>
        )}
        {el.beautiful_view && (
          <span>
            <img src={check_mark} alt="" />
            ԳԵՂԵՑԻԿ ՏԵՍԱՐԱՆ
          </span>
        )}
        {el.park && (
          <span>
            <img src={check_mark} alt="" />
            ԶԲՈՍԱՅԳԻ
          </span>
        )}
        {el.playground && (
          <span>
            <img src={check_mark} alt="" />
            ԽԱՂԱՀՐԱՊԱՐԱԿ
          </span>
        )}
        {el.garage && (
          <span>
            <img src={check_mark} alt="" />
            ԱՎՏՈՏՆԱԿ
          </span>
        )}
        {el.parking && (
          <span>
            <img src={check_mark} alt="" />
            ԱՎՏՈՀԱՆԳՐՎԱՆ
          </span>
        )}
        {el.two_sided && (
          <span>
            <img src={check_mark} alt="" />
            ԵՐԿԿՈՂՄԱՆԻ
          </span>
        )}
        {el.sweeming_pool && (
          <span>
            <img src={check_mark} alt="" />
            ԼՈՂԱՎԱԶԱՆ
          </span>
        )}
      </div>
    </div>
  );
}
